export class ObjectTrackRequest {
    imei: string;
    fromdate: number;
    todate: number;
    stoptime: number;
}